import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AuthResponse, UserProfile } from '../types/user';
import { UserRole } from '../types/user';
import { useAuthStore } from '../stores/authStore';

export function useAuth() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const ready = useAuthStore((s) => s.ready);
  const hydrate = useAuthStore((s) => s.hydrate);
  const setFromAuthResponse = useAuthStore((s) => s.setFromAuthResponse);
  const setUserProfile = useAuthStore((s) => s.setUserProfile);
  const logoutStore = useAuthStore((s) => s.logout);

  useEffect(() => {
    void hydrate();
  }, [hydrate]);

  const loginSuccess = useCallback(
    (auth: AuthResponse, redirectTo?: string) => {
      setFromAuthResponse(auth);
      const role = auth.user.role as UserRole;
      const fallback =
        role === UserRole.ADMIN ? '/admin/dashboard' : '/portal/dashboard';
      navigate(redirectTo ?? fallback, { replace: true });
    },
    [navigate, setFromAuthResponse],
  );

  const logout = useCallback(() => {
    logoutStore();
    navigate('/login', { replace: true });
  }, [logoutStore, navigate]);

  return {
    user,
    ready,
    loginSuccess,
    logout,
    setUser: (u: UserProfile | null) => setUserProfile(u),
  };
}
